export const LOCAL_STORAGE_THEME_KEY = 'suiteTheme';
export const LOCAL_STORAGE_OFFICE_THEME_PREFERRED_KEY = 'suiteOfficeThemePreferred';
export const LOCAL_STORAGE_MODE_KEY = 'isDarkMode';
